import { createAction } from "@reduxjs/toolkit";
import type { ReportAnIssueBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const reportIssue = createApiThunk<void, ReportAnIssueBody>(
  "users/reportIssue",
  async (body: ReportAnIssueBody, { extra: { sharedRepository } }) => {
    return sharedRepository!.reportIssue(body);
  },
);

export const resetReportIssue = createAction("shared/resetReportIssue");
